import React, { useState } from "react";
import { Button, Grid, TextField, CircularProgress } from "@mui/material";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";

const GetIMEI = () => {
  const [data, setData] = useState<any>(null);
  const [msisdn, setmsisdn] = useState("");

  const [action, setAction] = useState<Boolean>(false);

  const columnDefs: ColDef[] = [
    {
      field: "FirstUsed",
      headerName: "FirstUsed Date",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "LastUsed",
      headerName: "LastUsed Date",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "IMEI",
      headerName: "IMEI",
      filter: true,
      resizable: true,
      sortable: true,
    },
  ];
  const handleGetBundles = async () => {
    setData(null);
    toast.dismiss();
    if (msisdn.trim().length > 9) {
      setAction(true);
      requestBundles();
    } else {
      toast.error("Please enter valid  msisdn.");
    }
  };

  const requestBundles = async () => {
    await axiosInterceptorInstance
      .get(`/dashboard/IMEIDetails?MSISDN=${msisdn.trim()}`)
      .then((res: any) => {
        setAction(false);
        const apiresponse = JSON.parse(res.data.body);
        if (apiresponse.Data.length == 0) {
          toast.error("Record not found.");
        } else {
          setData(apiresponse?.Data);
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };
  const onGridReady = (params: { api: { sizeColumnsToFit: () => void } }) => {
    params.api.sizeColumnsToFit();
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">IMEI Details</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <TextField
                className="formControl"
                label="MSISDN"
                variant="outlined"
                value={msisdn}
                onChange={(e) => setmsisdn(e.target.value)}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>

            <Grid item xs={4}>
              {!action && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>

      {data && (
        <div className="ag-theme-alpine">
          <AgGridReact
            paginationPageSize={12}
            pagination={true}
            domLayout="autoHeight"
            rowData={data}
            columnDefs={columnDefs}
            enableCellTextSelection={true}
            onGridReady={onGridReady}
          ></AgGridReact>
        </div>
      )}
    </motion.div>
  );
};

export default GetIMEI;
